module.exports = __webpack_public_path__ + "static/netcompany-index-14534ce01376264edb426e3759004292.png";